import { createActions } from 'redux-actions';

export const routerUiActions = createActions({
  SET_ROUTER_KEY: key => key,

}, { prefix: 'MT_ROUTER_UI' });
